/* global bocAmchart4, chartLanguage, am4charts, gaVars, gtag */

/**
 * @typedef {{chart, data, dimension, getDimension, valetGroup, valetSeries, valetObservations}} bocInteractiveProcessor
 */

/**
 * Set the list of series and labels from the shortcode and add all the graphs to the chart
 * Also sets the valet_url based on the series list
 *
 * @param {AMConfig} chart Chart Object to be used to build this chart
 * @param {object} originalDataFromPostProcessor Array of series to be added
 * @returns {bocInteractiveProcessor} return object for further use
 */
bocAmchart4.InteractiveProcessor = function (chart, originalDataFromPostProcessor) {
    this.chart = chart;
    this.seriesPrefix = '';
    if (chart.bocSettings.args.hasOwnProperty('interactiveseriesprefix')) {
        this.seriesPrefix = chart.bocSettings.args.interactiveseriesprefix;
    }

    this.originalData = jQuery.extend(true, [], originalDataFromPostProcessor);

    // store the interactive processor for reuse
    this.chart.bocSettings.interactiveProcessor = this;

    if (typeof chart.bocSettings.interactiveConfig === 'undefined') {
        return;
    }

    this.config = chart.bocSettings.interactiveConfig;
    this.parameters = [];

    this.updateParametersInteractive = function (triggerDataCalculation, triggerAnalytics) {
        let chosenDatasets = [];
        for (var section = 0; section < this.config.sections.length; section++) {
            for (let parameter = 0; parameter < this.config.sections[section].parameters.length; parameter++) {
                var item = this.config.sections[section].parameters[parameter];
                let parameterID = this.config.sections[section].parameters[parameter].id;
                let display = document.getElementById(parameterID).parentNode.style.display;
                if (item.type === 'number' && item.currentValue == null && item.initial_value != null) {
                    this.parameters[item.id] = Number(item.initial_value);
                } else if (item.type === 'number' && item.currentValue != null) {
                    this.parameters[item.id] = Number(item.currentValue);
                } else if (item.type === 'checkbox') {
                    if (item.hasOwnProperty("currentValue")) {
                        this.parameters[item.id] = item.currentValue;
                    } else {
                        this.parameters[item.id] = item.checked;
                    }
                } else if (item.type === 'select') {
                    this.parameters[item.id] = item.currentValue;
                    if (!chosenDatasets.includes(this.parameters[item.id]) && display !== 'none') {
                        chosenDatasets.push(this.parameters[item.id]);
                    }
                }
            }
        }

        if (triggerDataCalculation) {
            let joinedDatasets = chosenDatasets.join(', ');
            this.delayedUpdateDataInteractive(this, triggerAnalytics, joinedDatasets);
        }
    };

    this.delayedUpdateDataInteractive = bocAmchart4.debounce(function (obj, triggerAnalytics, joinedDatasets) {
        obj.updateDataInteractive(triggerAnalytics, joinedDatasets);
    }, 100);

    this.updateDataInteractive = function (triggerAnalytics, joinedDatasets) {
        for (var section = 0; section < this.config.sections.length; section++) {
            this.config.sections[section].equation(this);
        }
        this.chart.invalidateData();
        if (bocAmchart4.debug(this.chart)) {
            var timeStart = performance.now();
            this.chart.events.once('validated', function () {
                // eslint-disable-next-line no-console
                console.log(
                    chart.bocSettings.id,
                    "validation time: ",
                    Math.round(performance.now() - timeStart) + "ms"
                );
            });
        }
        if (triggerAnalytics && typeof gaVars === 'object') {
            let title = bocAmchart4.getChartTitle(this.chart);
            let chartID = chart.bocSettings.id;
            gtag('event', 'dropdown_dataset_changed', {
                'event_category': 'AmCharts4',
                'event_label': title,
                'event_chart': chartID,
                'event_dataset': joinedDatasets
            });
        }
    };

    this.updateParametersInteractive();
    for (var section = 0; section < this.config.sections.length; section++) {
        this.config.sections[section].equation(this, originalDataFromPostProcessor);
    }
};

bocAmchart4.useSeriesInteractive = function (processor, startIndex, seriesArray) {
    var copiedData = [];
    var sourceData = processor.originalData;
    let preserveHidden = processor.chart.bocSettings.args.hasOwnProperty('preservehiddenstate')
        ? processor.chart.bocSettings.args.preservehiddenstate === 'true' : false;

    for (var index = 0; index < processor.chart.series.length; index++) {
        let series = processor.chart.series.getIndex(index);
        if (index >= startIndex && index < startIndex + seriesArray.length) {
            var originalSeriesName = seriesArray[index - startIndex];

            // Set the series label from source series
            var originalSeries = processor.chart.bocSettings.dataProcessor.valetSeries[originalSeriesName];
            series.name = originalSeries.label;
            let separator = (chartLanguage === "fr") ? " – " : "—";
            series.tooltipText = "{valueY}" + separator + series.name;

            if (!preserveHidden) {
                series.hiddenInLegend = false;
                series.show();
            }

            // copy the data from source series observations
            for (var id = 0; id < sourceData.length; id++) {
                copiedData[id] = copiedData[id] ? copiedData[id] : {'date': sourceData[id]['date']};
                copiedData[id][processor.seriesPrefix + (index + 1)] = sourceData[id][originalSeriesName];
            }
        } else {
            if (!preserveHidden) {
                series.hiddenInLegend = true;
                series.hide();
            }
        }
    }
    processor.chart.data = copiedData;
    bocAmchart4.hideAxesIfAllSeriesAreHidden(processor.chart);
};

/**
 * Iterate through column series and find the min and max of active (not hidden)
 * series data. Then set axis min and max to 0 if min > 0 or max < 0
 * @param {am4charts.XYChart} chart object
 * @param {object} axis values
 * @returns {undefined} void
 */
bocAmchart4.setMinMaxForColumns = function (chart, axis) {
    let min = Infinity;
    let max = -Infinity;

    chart.series.each(function (series) {
        // Check if the series is not hidden and is a ColumnSeries
        if (!series.isHidden && series instanceof am4charts.ColumnSeries) {
            series.dataItems.each(function (dataItem) {
                let value = dataItem.values.valueY.workingValue;
                if (value < min) {
                    min = value;
                }
                if (value > max) {
                    max = value;
                }
            });
        }
    });
    if (max !== Infinity && min > 0) {
        axis.min = 0;
    } else {
        axis.min = undefined;
    }
    if (max !== -Infinity && max < 0) {
        axis.max = 0;
    } else {
        axis.max = undefined;
    }
};

/**
 * Hides axes that do not have active series
 * @param {am4charts.XYChart} chart object
 * @returns {undefined} void
 */
bocAmchart4.hideAxesIfAllSeriesAreHidden = function (chart) {
    chart.yAxes.each((axis) => {
        // Check if all series related to this axis are hidden
        let allSeriesHidden = true;
        chart.series.each((series) => {
            if (series.yAxis === axis && series.visible) {
                allSeriesHidden = false;
            }
        });

        // Hide the axis if all series are hidden
        axis.visible = !allSeriesHidden;
        axis.renderer.grid.template.disabled = allSeriesHidden;
    });
};
